export default __webpack_public_path__ + "static/media/img-gtl-abp@2x.0baf8494.png";